import { iDataEventos } from "../../../interfaces/SuperAdmin/Pages/iDataEventos";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../ui-components/StyledTables";

interface RowEventosProps {
  evento: iDataEventos;
  i: number;
}

export const RowEventos: React.FC<RowEventosProps> = ({ evento, i }) => {
  //Restar 3 horas para concordar con el horario chileno
  const fechaOriginal = new Date(evento.fecha);
  const fechaAjustada = new Date(fechaOriginal);
  fechaAjustada.setHours(fechaOriginal.getHours() - 3);
  return (
    <StyledTableRow>
      <StyledTableCell sx={{ mb: 2 }}>{i}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>
        {evento.nombres} {evento.apellidos}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>
        {evento.organizacion}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>{evento.accion}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>{evento.aplicativo}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>
        {fechaAjustada.toLocaleString()}
      </StyledTableCell>
    </StyledTableRow>
  );
};
